export class AdresseIP {

    getAdresseIP() {
        return '/hebergement-cenou'
        //return 'https://api2.campusfaso.bf:8093'
        //return 'http://hebergement.campusfaso.bf:8083'
        //return 'http://192.168.43.22:8083'
        //return 'http://72.251.3.99:8093'
    }
    getAdresseIPINEFASO() {
        return '/inefaso'
        // return 'https://api2.campusfaso.bf:8082'
    }

}